<template>
  <q-dialog :visible="isVisible" :title="title" width="80vw" :innerScroll="false" @close="onCancel" :showFooter="false" @cancel="onCancel">
    <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px" size="mini" v-loading="loading">
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品编码:">
            {{ rowData.productCode }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称:">
            {{ rowData.productName }}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-table
            stripe
            border
            :header-cell-style="{ backgroundColor: '#F4F8FB' }"
            highlight-current-row
            :data="tableData.list"
            :height="300"
            v-loading="loading"
          >
            <el-table-column label="A类价" prop="dailyRetailPrice" min-width="100"></el-table-column>
            <el-table-column label="组合S级到手价" prop="groupPriceS" min-width="130"></el-table-column>
            <el-table-column label="组合A级到手价" prop="groupPriceA" min-width="130"></el-table-column>
            <el-table-column label="组合日常到手价" prop="groupPriceDaily" min-width="130"></el-table-column>
            <el-table-column label="单品S级到手价" prop="singlePriceS" min-width="130"></el-table-column>
            <el-table-column label="单品A级到手价" prop="singlePriceA" min-width="130"></el-table-column>
            <el-table-column label="单品日常到手价" prop="singlePriceDaily" min-width="130"></el-table-column>
            <el-table-column label="更新人" prop="updatedBy" min-width="90"></el-table-column>
            <el-table-column label="更新时间" prop="updatedDate" min-width="160"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '调整记录';
    },
  },
  data() {
    return {
      loading: false,
      editForm: {},
      rules: {},
      tableData: [],
      reportName: 'productWholePriceModifyInfo',
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: [
          {
            attributeName: 'productCode', //产品编码
            val: this.rowData.productCode,
            op: '=',
          },
        ],
        orderList: [],
        orderByColumn: '',
        orderType: '',
        hasCount: 'Y',
      };
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-pagination__editor.el-input 
      width 50px
</style>
